import React, { memo } from 'react'
import AddIcon from 'transfix-icons/build/AddIcon'
import { Button } from 'transfix-ui/components/Button'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { NoSavedLanesIcon } from '../NoSavedLanesIcon'

export interface ISavedLanesPageEmptyProps {
  onAdd: () => void
}

const SavedLanesPageEmpty = memo<ISavedLanesPageEmptyProps>(({ onAdd }) => {
  return (
    <Box
      data-test='saved-lanes-empty-page'
      display='flex'
      flexDirection='column'
      alignItems='center'
      gap={4}>
      <NoSavedLanesIcon />
      <Typography variant='subtitle1'> No saved lanes</Typography>
      <Typography color='textSecondary'>
        Lanes you&apos;ve saved to be notified about will be listed here
      </Typography>
      <Button
        color='primary'
        startIcon={<AddIcon />}
        onClick={onAdd}
        data-test='saved-lanes-empty-create-button'>
        Add Saved Lane
      </Button>
    </Box>
  )
})

export default SavedLanesPageEmpty
